import * as properties from './properties';
import Avatar from './avatar';
import Main from './views/main';
import Card from './views/card';
import ListCardItem from './views/list-card-item';
import ListItem from './views/list-item';
import BasicForm from './forms/basic';

const ThingExtension = {
  views: {
    main: () => Main,
    card: () => Card,
    listCardItem: () => ListCardItem,
    listItem: () => ListItem,
  },
  forms: {
    basic: () => BasicForm,
  },
  avatar: () => Avatar,
  properties,
  meta: {
    name: 'Anything',
  },
};
export default ThingExtension;
